import React, { useEffect, useState } from "react";
import { getVisorPdfUrl, getVisorPdfUrlAvanzarRetroceder, getVisorPdfInfo } from "../../../services/visorPdf"; // Importa el servicio
import "./visorPdf.css"; // Asegúrate de tener el archivo CSS vinculado
import { getApiClientFront, getApiClientBack, getURLFront } from "../../../api/api";

// const apiUrlMap = {
//   // "pruebabopiweb.oepm.es": "https://pruebabopiweb.oepm.es",
//   "pruebasede.oepm.gob.es": "https://pruebasede.oepm.gob.es/bopi",
//   "prebopiweb.oepm.es": "https://prebopiweb.oepm.es",
//   "bopiweb.oepm.es": "https://bopiweb.oepm.es",
  
//   "localhost": "http://localhost:3000/bopi",
//   "defaultApiUrl": "Error",
// };

// const baseURL = apiUrlMap[window.location.hostname] || apiUrlMap["defaultApiUrl"];
// // const baseURL = "http://localhost:3000";

const VisorPdf = () => {
  const idPag = "";
  const [pdfUrl, setPdfUrl] = useState(null);  // URL del PDF
  const [currentIdPagina_Csv, setCurrentIdPagina_Csv] = useState(null);  // ID del PDF actual

  useEffect(async() => {
    // permitir acceso directo
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");

    const baseURL = await getURLFront();
    window.opener?.postMessage({ tipo: "visorPdfReady" }, baseURL);

    const handleMessage = async (event) => {      
      const urlCompleta = new URL("/bopi", event.origin).href;
      if (urlCompleta !== baseURL) return;
      
      const { resultado } = event.data;
      if (resultado?.id_PAGINA_CSV) {        
        setCurrentIdPagina_Csv(resultado.id_PAGINA_CSV);

        const idPaginaCsv = await getVisorPdfInfo(resultado.id_PAGINA_CSV);
        if (idPaginaCsv) {
          setCurrentIdPagina_Csv(idPaginaCsv);
        }

        const url = await getVisorPdfUrl(resultado.id_PAGINA_CSV);
        setPdfUrl(url);
      } else {
        setCurrentIdPagina_Csv(id);

        const idPaginaCsv = await getVisorPdfInfo(id);
        if (idPaginaCsv) {
          setCurrentIdPagina_Csv(idPaginaCsv);
        }

        const url = await getVisorPdfUrl(id);
        setPdfUrl(url);
      }
    };

    window.addEventListener("message", handleMessage);  // Escuchamos los mensajes
    return () => window.removeEventListener("message", handleMessage);  // Limpiamos el evento cuando el componente se desmonte
  }, []);

  // Función para manejar el retroceso de ID
  const handlePrevPdf = () => {
    if (!currentIdPagina_Csv) return;
  
    const match = currentIdPagina_Csv.match(/(.*-)(\d+)$/);
    if (match) {
      const prefix = match[1]; // Parte inicial del ID
      const number = parseInt(match[2], 10);
  
      if (number > 1) {
        const newNumber = String(number - 1).padStart(8, '0');
        const newId = `${prefix}${newNumber}`;
  
        setCurrentIdPagina_Csv(newId);
        // setPdfUrl(getVisorPdfUrlAvanzarRetroceder(newId));
        getVisorPdfUrlAvanzarRetroceder(newId)
        .then(url => {
          setPdfUrl(url);
        });
      }
    }
  };
  
  const handleNextPdf = () => {
    if (!currentIdPagina_Csv) return;
  
    const match = currentIdPagina_Csv.match(/(.*-)(\d+)$/);
    if (match) {
      const prefix = match[1];
      const number = parseInt(match[2], 10);
      const newNumber = String(number + 1).padStart(8, '0');
      const newId = `${prefix}${newNumber}`;
  
      setCurrentIdPagina_Csv(newId);
      // setPdfUrl(getVisorPdfUrlAvanzarRetroceder(newId));
      getVisorPdfUrlAvanzarRetroceder(newId)
      .then(url => {
        setPdfUrl(url);
      });
    }
  };

  return (
    <div>
      <h1>Visor PDF</h1>
      <h2>Página {currentIdPagina_Csv}</h2>
      <p>A continuación se muestra la página del Boletín Oficial de la Propiedad Industrial que contiene la anotación. Si la anotación no se pudiera localizar en la página actual, puede ser porque se inicia la anotación en esta página y se muestra en la siguiente.</p>
      <div className="buttons-container">
        <button 
          onClick={handlePrevPdf} 
          className="pagination previous" 
          disabled={currentIdPagina_Csv <= 1}
        >
          {'<<'} Página anterior 
        </button>
        <button 
          onClick={handleNextPdf} 
          className="pagination next" 
          disabled={!currentIdPagina_Csv}
        >
          Página siguiente {'>>'}
        </button>
      </div>

      {pdfUrl ? (
        <iframe
          src={pdfUrl}  // Aquí se coloca la URL generada por el backend
          width="100%"  // 100% de ancho
          height="800px"  // Alto del iframe
          title="PDF Viewer"
          style={{ border: "none" }}  // Sin bordes en el iframe
        />
      ) : (
        <p>Cargando PDF...</p>  // Mensaje mientras se carga el PDF
      )}
    </div>
  );
};

export default VisorPdf;
